module.exports = __webpack_public_path__ + "static/media/realtalk_sd_ritsu8aae07d639257f2efd49f732dfe34b64.webp";